
export enum BusinessLevelMarketingSubscriptionType {
  PersistenceOnly = 'PersistenceOnly',
  Mailchimp = 'Mailchimp',
  Mailerlite = 'Mailerlite',
}
